export default function ApercuReservation({ reservation }) {
    if (!reservation) {
        return <p className="text-center text-gray-500">Chargement des informations...</p>;
    }

    const formatDate = (date) => {
        return new Date(date).toLocaleDateString();
    };

    const getStatusLabel = (status) => {

        switch (status) {
            case 1:
                return { text: "Approuvée", color: "text-green-800 bg-green-600 font-bold bg-opacity-10" };
            case 2:
                return { text: "Confirmée", color: "text-blue-800 bg-blue-600 font-bold bg-opacity-10" };
            case 0:
                return { text: "En attente", color: "text-yellow-800 bg-yellow-600 font-bold bg-opacity-10" };
            case -1:
                return { text: "Rejetée", color: "text-red-800 bg-red-600 font-bold bg-opacity-10" };
            case -2:
                return { text: "Annulée", color: "text-red-800 bg-red-600 font-bold bg-opacity-10" };
            case 3:
                return { text: "Terminée", color: "text-indigo-800 bg-indigo-600 font-bold bg-opacity-10" };
            default:
                return { text: "Inconnu", color: "text-gray-800 bg-gray-600 font-bold animate-pulse bg-opacity-10" };
        }
    };

    const statusLabel = getStatusLabel(reservation.status);

    return (
        <div className="w-full p-6 bg-white rounded-lg shadow-md dark:bg-gray-800">
            {/* Titre principal avec Material Style */}
            <h2 className="mb-4 text-3xl font-semibold text-gray-800 dark:text-gray-20">Réservation</h2>

            {/* Card des informations principales */}
            <div className="w-full p-4 mb-4 bg-gray-100 rounded-lg dark:bg-gray-700">
                <p className="text-lg font-medium text-gray-700 dark:text-gray-200">ID de Réservation</p>
                <p className="text-base text-gray-600 dark:text-gray-200">{reservation.id}</p>
            </div>

            {/* Dates de réservation */}
            <div className="w-full p-4 mb-4 bg-gray-100 rounded-lg dark:bg-gray-700">
                <h5 className="text-xl font-semibold text-gray-800 dark:text-gray-200">Dates</h5>
                <p className="text-base text-gray-600 dark:text-gray-200">
                du {formatDate(reservation.startdate)} au {formatDate(reservation.endDate)}
                </p>
            </div>

            {/* Statut de la réservation */}
            <div className="w-full p-4 mb-4 bg-gray-100 rounded-lg dark:bg-gray-700">
                <h5 className="text-xl font-semibold text-gray-800 dark:text-gray-200">Statut</h5>
                <div
                    className={`mt-2 py-1 flex justify-center items-center font-bold  rounded-full ${statusLabel.color}`}
                    style={{ width: 100, fontSize: 14 }}
                    >
                    {statusLabel.text}
                </div>
            </div>

        </div>
    );
}
